var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12676_5563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73065 14.875C7.70815 15.8192 9.29482 15.8192 10.2723 14.875M12.0432 9.77856C12.0432 9.53347 12.0432 9.41093 12.08 9.30185C12.1869 8.98451 12.4696 8.86197 12.7529 8.73306C13.0702 8.58785 13.2289 8.5156 13.3869 8.50285C13.5654 8.48868 13.7446 8.52693 13.8976 8.61264C14.1002 8.72597 14.2418 8.94272 14.3863 9.11839C15.0543 9.93014 15.3886 10.336 15.5104 10.783C15.6096 11.1442 15.6096 11.5225 15.5104 11.883C15.3327 12.5361 14.7695 13.0829 14.3523 13.5901C14.1391 13.8486 14.0322 13.9783 13.8976 14.0541C13.7419 14.1404 13.5642 14.1786 13.3869 14.1638C13.2289 14.1511 13.0702 14.0788 12.7522 13.9336C12.4689 13.8047 12.1869 13.6822 12.08 13.3648C12.0432 13.2558 12.0432 13.1332 12.0432 12.8888V9.77856ZM4.95982 9.77856C4.95982 9.46972 4.95132 9.19276 4.70199 8.97601C4.61132 8.89739 4.4909 8.84285 4.25078 8.73306C3.93274 8.58856 3.77407 8.5156 3.61611 8.50285C3.14365 8.4646 2.88936 8.7876 2.61736 9.1191C1.94869 9.93014 1.61436 10.336 1.49182 10.7837C1.39335 11.1435 1.39335 11.5232 1.49182 11.883C1.67032 12.5361 2.23415 13.0829 2.65065 13.5901C2.91344 13.9088 3.1649 14.2 3.61611 14.1638C3.77407 14.1511 3.93274 14.0788 4.25078 13.9336C4.49161 13.8238 4.61132 13.7693 4.70199 13.6907C4.95132 13.4739 4.95982 13.197 4.95982 12.8881V9.77856Z",
    stroke: "#1C738E",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41797 11.3334V8.50008C1.41797 4.58796 4.58918 1.41675 8.5013 1.41675C12.4134 1.41675 15.5846 4.58796 15.5846 8.50008V11.3334",
    stroke: "#1C738E",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12676_5563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.7416ba1c6614a0598038c7ca6db03871.svg";
export { ForwardRef as ReactComponent };